import SessionService from '@/services/session.service';
import axios from "axios";

export const sessionModule = {
    namespaced: true,
    state: {
        requests: [],
        session: {},
        sessions: new Map(),
        presentLogs: new Map(),
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async createSession({commit, dispatch}, {classId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createSession");
            return SessionService.createSession(axiosSource, classId, data).then(
                async data => {
                    commit('insertSession', data)
                    await dispatch('clearRequest', "createSession");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateSession({commit, dispatch}, {classId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateSession");
            return SessionService.updateSession(axiosSource, classId, data).then(
                async data => {
                    commit('updateSessionData', data)
                    await dispatch('clearRequest', "updateSession");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteSession({commit, dispatch}, {classId, sessionId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteSession");
            return SessionService.deleteSession(axiosSource, classId, sessionId).then(
                async data => {
                    commit('removeSessionFromList', sessionId)
                    await dispatch('clearRequest', "deleteSession");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getSession({commit, dispatch}, {classId, sessionId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getSession");
            return SessionService.getSession(axiosSource, classId, sessionId).then(
                async data => {
                    commit('updateActiveSession', data)
                    await dispatch('clearRequest', "getSession");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listSessions({commit, dispatch}, classId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listSessions");
            return SessionService.listSessions(axiosSource, classId).then(
                async data => {
                    commit('updateSessionsList', data);
                    await dispatch('clearRequest', "listSessions");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listPresentLogs({commit, dispatch}, {classId, sessionId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listPresentLogs");
            return SessionService.listPresentLogs(axiosSource, classId, sessionId).then(
                async data => {
                    commit('updatePresentLogsList', data);
                    await dispatch('clearRequest', "listPresentLogs");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async redirectToSession({dispatch}, {classId, sessionId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "redirectToSession");
            return SessionService.getSessionUrl(axiosSource, classId, sessionId).then(
                async data => {
                    window.location.href = data.link
                    await dispatch('clearRequest', "redirectToSession");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateSessionsList(state, data) {
            state.sessions = new Map()
            for (const entity of data) {
                state.sessions.set(entity.id, entity)
            }
        },
        insertSession(state, data) {
            state.sessions.set(data.id, data)
        },
        updateSessionData(state, data) {
            state.sessions.set(data.id, data)
        },
        updatePresentLogsList(state, data) {
            state.presentLogs = new Map()
            for (const entity of data) {
                state.presentLogs.set(entity.user_id, entity)
            }
        },
        removeSessionFromList(state, sessionId) {
            state.sessions.delete(sessionId)
        },
        updateActiveSession(state, data) {
            state.session = data;
        }
    }
};